import React from "react";

import { IconUser } from "~/components/icon";

export const UserAvatar: React.FC = () => (
	<div className="flex size-8 shrink-0 items-center justify-center rounded-full border border-gray-300 bg-white text-primary-600">
		<IconUser className="size-4" />
	</div>
);
